/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

const phoneRegex = /^(\+|00)?\d{7,16}$/;

export const isValidPhone = (phone: string) => {
  return (
    !phone ||
    !!phone.match(phoneRegex) ||
    "Please provide a valid phone number (without spaces)"
  );
};
